<template>
  <div
    class="flex-1 flex flex-col p-4 -m-4"
    :class="{
      'overflow-y-auto': scrollable,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    scrollable: {
      type: Boolean,
      default: true,
    }
  }
}
</script>

<style lang="scss" scoped>
</style>